import axios from 'axios';


const apiAxios = axios.create({
    baseURL: '/api',
    timeout: 90000,
    // headers: {
    //     'Authorization': `token ${localStorage.getItem('token')}`,
    //     'Refresh': localStorage.getItem('refreshToken'),
    //     'spooken': localStorage.getItem('spooken'),
    //     'user': localStorage.getItem('user'),
    //     'user_ui': localStorage.getItem('user_ui'),
    // }
    // withCredentials: true
});


const requestHandler = request => {
    request.headers = {
        'Authorization': `token ${localStorage.getItem('token')}`,
        'Refresh': localStorage.getItem('refreshToken'),
        'spooken': localStorage.getItem('spooken'),
        'user': localStorage.getItem('user'),
        'userui': localStorage.getItem('user_ui'),
    }
    return request;
};

const responseHandler = async response => {
    return response;
};

const errorHandler = async error => {
    const config = error.config;
    if (error?.response?.status === 401 && !config._retry) {
        config._retry = true;
        try {
            const res = await apiAxios.post('/refresh', {}, { withCredentials: true })

            if (res?.status === 200) {
                localStorage.setItem('token', await res?.headers?.['newtoken'])


                if (!!error.config?.data) {
                    error.config = { ...error.config, data: JSON.parse(error?.config?.data) }
                }

                return apiAxios(error.config)
            }
        } catch (error) {
            // window.location.href = '/';
            // localStorage.clear()
            console.log('ერრორ', error);
            return error
        }

    }
    if (error?.response?.status === 503) {
        window.location.href = '/'
    }
    if (error?.response?.status === 498) {
        localStorage.clear()
        window.location.href = '/'
    }

    return Promise.reject(error);
};


apiAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

apiAxios.interceptors.response.use(
    (response) => responseHandler(response),
    async (error) => errorHandler(error)

);



export default apiAxios;
